import { AppRoute } from '@core/route-data/models/app-routes';
import { LoginRecoveryPath } from '@pages/login-recovery-options/routes/login-recovery-path.enum';
import { LoginRecoveryOptionsListComponent } from '@pages/login-recovery-options/components/login-recovery-options-list/login-recovery-options-list.component';
import { RecoverUsernameComponent } from '@pages/login-recovery-options/components/recover-username/recover-username.component';
import { RecoverPasswordComponent } from '@pages/login-recovery-options/components/recover-password/recover-password.component';
import { RecoverCompanyNameComponent } from '@pages/login-recovery-options/components/recover-company-name/recover-company-name.component';
import { RecoverEmailSentComponent } from '@pages/login-recovery-options/components/recover-email-sent/recover-email-sent.component';
import { hasRecoveryEmailSentAccess } from '@pages/login-recovery-options/guards/has-recovery-email-sent-access';

export const loginRecoveryRoutes: AppRoute[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LoginRecoveryPath.OptionsList,
    data: { prefetchTarget: LoginRecoveryPath.OptionsList },
  },
  {
    path: LoginRecoveryPath.OptionsList,
    component: LoginRecoveryOptionsListComponent,
  },
  {
    path: LoginRecoveryPath.ForgotUsername,
    component: RecoverUsernameComponent,
  },
  {
    path: LoginRecoveryPath.ForgotPassword,
    component: RecoverPasswordComponent,
  },
  {
    path: LoginRecoveryPath.ForgotCompanyName,
    component: RecoverCompanyNameComponent,
  },
  {
    path: LoginRecoveryPath.EmailSent,
    canMatch: [hasRecoveryEmailSentAccess],
    component: RecoverEmailSentComponent,
  },
];
